export enum RequestAccessResult {
  SUCCESS,
  ERROR,
  NOT_SENT,
}
